export const NoConnectionToast = ({ closeToast, toastProps }) => (
    <div className="flex items-center select-none">
        <i className="bx bx-wifi-off text-3xl mr-3"></i>
        <span className="text-xl">API is offline</span>
    </div>
)